import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { BlogSection } from '@/types/blog';

interface BlogTOCProps {
  sections: BlogSection[];
}

/**
 * Table of Contents component for blog posts with structured sections
 * Automatically generates a collapsible navigation menu from section data
 */
const BlogTOC: React.FC<BlogTOCProps> = ({ sections }) => {
  const [isOpen, setIsOpen] = useState(true);
  console.info('BlogTOC - sections received:', Array.isArray(sections) ? sections.length : 'n/a');
  // Static TOC: render all provided sections without filtering


  return (
    <div className="mb-8 border border-joerg-200 dark:border-joerg-700 rounded-lg overflow-hidden bg-gradient-subtle">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-joerg-50 dark:hover:bg-joerg-800 transition-colors"
        aria-expanded={isOpen}
      >
        <span className="font-semibold text-joerg-900 dark:text-joerg-100">
          Inhaltsverzeichnis
        </span>
        <ChevronDown 
          className={`h-5 w-5 text-joerg-600 dark:text-joerg-400 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      
      <div
        className={`transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
        } overflow-hidden`}
      >
        <nav className="px-6 py-4 border-t border-joerg-200 dark:border-joerg-700">
          <ol className="space-y-3">
            {sections.map((section, index) => (
              <li key={section.id}>
                <a
                  href={`#${section.id}`}
                  className="text-left text-joerg-700 dark:text-joerg-300 hover:text-primary dark:hover:text-primary transition-colors flex items-start gap-2 w-full group"
                  aria-label={`Zum Abschnitt ${section.title}`}
                >
                  <span className="text-joerg-500 dark:text-joerg-500 font-medium min-w-[24px]">
                    {index + 1}.
                  </span>
                  <span className="group-hover:underline">{section.title}</span>
                </a>
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default BlogTOC;
